import React, { useState } from "react";


import {
	Box,
	Button,
	Dialog,
	DialogTitle,
	Grid,
	IconButton,
	TextField,
	MenuItem,
	DialogActions,
} from "@mui/material";
import {
	Download,
	FileUpload,
} from "@mui/icons-material";
import { Stack } from "@mui/system";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { Close as CloseIcon } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { createPromoBatch } from "../../redux/actions/promocode.actions";
import { Toastify } from "../../services/toastify/toastifyContainer.jsx";
import ButtonOnly from "../../components/Comman/button-new/buttonNew.jsx";
import { FaPaperPlane, FaEdit } from "react-icons/fa";
import { toast } from "react-toastify";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
	"& .MuiDialogContent-root": { padding: theme.spacing(2) },
	"& .MuiDialogActions-root": { padding: theme.spacing(1) },
}));

function BootstrapDialogTitle(props) {
	const { children, onClose, ...other } = props;

	return (
		<DialogTitle sx={{ m: 0, p: 2 }} {...other}>
			{children}
			{onClose ? (
				<IconButton
					aria-label='close'
					onClick={onClose}
					sx={{
						position: "absolute",
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}>
					<CloseIcon color="error" />
				</IconButton>
			) : null}
		</DialogTitle>
	);
}

BootstrapDialogTitle.propTypes = {
	children: PropTypes.node,
	onClose: PropTypes.func.isRequired,
};
const AddModal = (props) => {
	const {
		campaigns,
		clients,
		openModal,
		handleModal,
		isEdit = false,
	} = props;

	const dispatch = useDispatch();

	const [file, setFile] = useState(null);
	const [batch, setBatch] = useState({
		client_id: "",
		campaign_id: "",
		consumptionType: "",
		totalCount: "",
		expiresAt: ""
	});
	const formatDateForApi = (dateString) => {
		const date = new Date(dateString);
		return date.toISOString(); // This will format the date as "YYYY-MM-DDTHH:mm:ss.sssZ"
	};



	const clientsArr = clients.map((client) => ({
		id: client.client_id,
		name: client.client_name,
	}));

	const campaignArr = Array.isArray(campaigns) ? campaigns
		.filter((campaign) => campaign.client_id === batch.client_id)
		.map((campaign) => ({
			id: campaign.campaign_id,
			name: campaign.name,
		})) : "";

	const handleDownload = () => {
		// using Java Script method to get PDF file
		fetch("SamplePromoBatch.xlsx").then((response) => {
			response.blob().then((blob) => {
				// Creating new object of PDF file
				const fileURL = window.URL.createObjectURL(blob);
				// Setting various property values
				let alink = document.createElement("a");
				alink.href = fileURL;
				alink.download = "SamplePromoBatch.xlsx";
				alink.click();
				Toastify({ data: "success", msg: `FileSheet Is Downloaded Successfully....` });
			}).catch((err) => {
				Toastify({ data: "error", msg: err });
			});
		});
	};

	const handleFileUpload = (e) => {
		if (e.target.files[0]) {
			setFile(e.target.files[0]);
			Toastify({ data: "success", msg: `FileSheet Is Uploaded Successfully....` });
		} else {
			Toastify({ data: "error", msg: `Something went wrong....` });
		}
	};

	const handleInputChange = (e) => {
		const { name, value } = e.target;

		setBatch((prevBatch) => {
			const newBatch = { ...prevBatch, [name]: value };
			if (name === "consumptionType") {
				newBatch.totalCount = value === "single" ? "1" : "";
			}
			return newBatch;
		});
	};

	const handleCloseForm = () => {
		handleModal(false);
	};


	const handleSubmit = async (e) => {
		if (batch?.campaign_id !== "" && batch?.client_id !== "") {
			e.preventDefault();
			try {
				const formData = new FormData();
				const dateFormat = formatDateForApi(batch?.expiresAt);

				formData.append("file", file);
				formData.append("campaign_id", batch.campaign_id);
				formData.append("consumptionType", batch.consumptionType);
				formData.append("totalCount", batch.totalCount);
				formData.append("expiresAt", dateFormat);

				for (var pair of formData.entries()) {
					console.log(pair[0] + ", " + pair[1]);
				}
				dispatch(createPromoBatch(formData));
				handleCloseForm();
			} catch (error) {
				console.log(error);
			}
		} else {
			handleModal(true);
			toast.warning("Please Fill all the fields...");
		}
	};

	return (
		<BootstrapDialog
			onClose={handleCloseForm}
			aria-labelledby='customized-dialog-title'
			open={openModal}>
			<BootstrapDialogTitle
				id='customized-dialog-title'
				onClose={handleCloseForm}
				sx={{ textAlign: "center", backgroundColor: "rgba(0, 165, 162, 0.7)", color: "white" }}
			>
				{isEdit ? `Update Promo Codes` : `Add Promo Codes`}
			</BootstrapDialogTitle>
			<hr className="mt-0" />
			<form onSubmit={handleSubmit}>
				<Box
					sx={{
						"& .MuiTextField-root": { mt: 4, ml: 7, width: "80%" },
					}}>
					<Grid container direction='row'>
						<Grid item xs={6}>
							<TextField
								required
								id='client'
								name='client_id'
								select
								label='Client'
								placeholder='Select client'
								value={clientsArr.client_id}
								disabled={false}
								onChange={handleInputChange}>
								{clients.map((option) => (
									<MenuItem key={option.client_id} value={option.client_id}>
										{option.name}
									</MenuItem>
								))}
							</TextField>
							<TextField
								required
								id='campaign'
								name='campaign_id'
								select
								label='Campaign'
								placeholder='Select campaign'
								value={campaigns.campaign_id}
								disabled={false}
								onChange={handleInputChange}>
								{campaignArr.map((option, index) => (
									<MenuItem key={index} value={option.id}>
										{option.name}
									</MenuItem>
								))}
							</TextField>
						</Grid>
						<Grid item xs={5}>
							<TextField
								required
								id="consumptionType"
								name="consumptionType"
								label="Consumption Type"
								select
								placeholder="Enter Consumption Type"
								value={batch.consumptionType}
								disabled={false}
								onChange={handleInputChange}

							>
								<MenuItem value="single">Single</MenuItem>
								<MenuItem value="multiple">Multiple</MenuItem>
							</TextField>
							<TextField
								required
								id="totalCount"
								name="totalCount"
								label="Total Count"
								placeholder="Enter Total Count"
								value={batch.totalCount}
								disabled={batch.consumptionType === "single"}
								onChange={handleInputChange}
							/>
						</Grid>
						<TextField
							required
							id="expiresAt"
							name="expiresAt"
							label="Expires At"
							type="datetime-local"
							value={batch.expiresAt}
							disabled={false}
							onChange={handleInputChange}
							InputLabelProps={{
								shrink: true,
							}}
						/>
						{!isEdit && (
							<Grid item xs={12}>
								<Stack
									sx={{ ml: 7, mt: 5 }}
									direction='row'
									alignItems='center'
									spacing={2}>
									<Button
										variant='contained'
										startIcon={<FileUpload />}
										type='upload'
										component='label'
										onChange={handleFileUpload}>
										<input hidden accept='.xlsx' type='file' />
										Upload new batch
									</Button>

									<Button
										variant='outlined'
										startIcon={<Download />}
										type='download'
										component='label'
										onClick={handleDownload}>
										Sample sheet format
									</Button>
								</Stack>
								<p className="ms-5 mt-3 text-danger">{file?.name}</p>
								<hr className="mb-1" />
							</Grid>
						)}
						<DialogActions style={{ marginLeft: "15rem" }}>
							<ButtonOnly
								buttonLabel={isEdit ? "Update" : "Submit"}
								buttonIcon={isEdit ? <FaEdit /> : <FaPaperPlane />}
								buttonClick={handleSubmit}
							/>
						</DialogActions>
					</Grid>
				</Box>
			</form>
		</BootstrapDialog>
	);
};

export default AddModal;
